export enum EBuilderIoModelTypes {
  page = 'page',
  section = 'section',
  data = 'data',
  props = 'props',
}
